export default "__VITE_ASSET__BxoLywzi__"